module.exports = __webpack_public_path__ + "media/images/editar-a0065e42dd090dd9b77dc4113203d5e1.svg";